import { ChangeDetectionStrategy, Component, Input, OnChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { GitPathMapper, SubClassOfGitUiDisplayComponent } from '../git-path-mapper';

@Component({
  selector: 'y42-git-ui-display-outlet',
  templateUrl: './git-ui-display-outlet.component.html',
  styleUrls: ['./git-ui-display-outlet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitUiDisplayOutletComponent implements OnChanges {
  constructor(private readonly gitPathMapper: GitPathMapper) {}

  @Input() path!: string | undefined;

  @Input() content!: string | undefined;

  @ViewChild('componentTarget', { read: ViewContainerRef, static: true }) componentTarget!: ViewContainerRef;

  matchedComponentPromise: Promise<SubClassOfGitUiDisplayComponent> | undefined | null = null;

  ngOnChanges() {
    this.loadComponent();
  }

  private async loadComponent() {
    this.componentTarget.clear();

    if (!this.path) {
      return;
    }

    this.matchedComponentPromise = this.gitPathMapper.getComponent(this.path);

    if (!this.matchedComponentPromise) {
      return;
    }
    const component = await this.matchedComponentPromise;
    const componentRef = this.componentTarget.createComponent(component);
    componentRef.instance.path = this.path;
    componentRef.changeDetectorRef.detectChanges();
  }
}
